import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { AccountClient, ChangePasswordAccountRequest } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  newPasswordCtrl = new FormControl('', [Validators.required]);
  oldPasswordCtrl = new FormControl('', [Validators.required]);
  isLogoutAllCtrl = new FormControl();
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private alertService: AlertService,
    private accountClient: AccountClient
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
  onSubmit() {
    if (this.newPasswordCtrl.valid && this.oldPasswordCtrl.valid) {
      this.spinner.show();
      this.accountClient.changePassword(new ChangePasswordAccountRequest({
        newPassword: this.newPasswordCtrl.value,
        oldPassword: this.oldPasswordCtrl.value,
        isLogoutAll: this.isLogoutAllCtrl.value
      }))
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.alertService.success('Thay đổi mật khẩu thành công', 'Thay đổi mật khẩu');
          this.close();
        });
    }
  }
}
